module.exports = __webpack_public_path__ + "static/img/logo-tope-subesup-mineduc3-61c6749.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-tope-subesup-mineduc3.png
// module id = bGts
// module chunks = 1